import { FitnessGoals } from "@/constants/fitnessGoal";
import { QUESTIONS_IDS } from "@/constants/questionsIds";
import { useLocalization } from "@/hooks/useLocalization";
import { useGender } from "@/utils/GenderProvider";
import { useFlowManager } from "@/utils/providers/FlowProvider";
import useAnswers from "@/utils/useAnswers";

export const useWeightPredictor = () => {
    const { getAnswersValue } = useAnswers();
    const { isFemale } = useGender();
    const { isEnglish } = useLocalization();
    const {
        isFlowType: { friends },
    } = useFlowManager({});

    const primaryGoal = getAnswersValue(QUESTIONS_IDS.PRIMARY_GOAL);

    const isWeightPredictor = Boolean(
        isFemale && primaryGoal === FitnessGoals.LoseWeight && isEnglish && !friends
    );

    return { isWeightPredictor };
};
